import { trackEvent } from '@/infra/tracking/analytics'
import { safeTrackCall } from '@/presentation/pages/common-analytics'

export namespace Analytics {
  export const trackSearchBar = safeTrackCall(
    async ({ term, to, source }: { term: string; to: string; source: string }) => {
      trackEvent('up_searchBar_search', {
        term,
        to,
        source
      })
    }
  )
}
